import moment from "moment";
import store from "@/store";

const kana = {
  validate: (value) => {
    if (value.length && value.match(/^[\u3040-\u309f\u30fc]+$/)) {
      return true;
    }
    return false;
  },
  message: (field) => `${field} にはひらがなを入力してください。`
};

const kana_alpha_num = {
  validate: (value) => {
    if (value.length && value.match(/^[a-zA-Z0-9\u3040-\u309f\u30fc]+$/)) {
      return true;
    }
    return false;
  },
  message: (field) => `${field} にはひらがな、半角英数字を入力してください。`
};

const gteThisMonth = {
  validate: (value) => {
    const targetMonth = moment(value, "YYYY-MM-01");
    const thisMonth = moment(new Date(), "YYYY-MM-01");

    return targetMonth.isSameOrAfter(thisMonth, "month");
  },
  message: (field) => `${field} は当月以降を指定してください。`
};

const emailCheck = {
  params: ["excludedId"],
  validate: (value, { excludedId = undefined }) => {
    return store
      .dispatch(`users/entity/emailCheck`, { email: value, excludedId })
      .then(() => {
        return true;
      })
      .catch(() => {
        return false;
      });
  },
  message: (field) => store.getters[`users/entity/errorMessages`].email[0]
};

const adminEmailCheck = {
  params: ["excludedId"],
  validate: (value, { excludedId = undefined }) => {
    return store
      .dispatch(`administrators/entity/emailCheck`, { email: value, excludedId })
      .then(() => {
        return true;
      })
      .catch(() => {
        return false;
      });
  },
  message: (field) => store.getters[`administrators/entity/errorMessages`].email[0]
};

const duplicateSelectCheck = {
  validate: (value) => {
    // 質問全体で選択された値を取得
    const selectedItems = store.getters[`templates/entity/selectedItems`]
    // 今回選択した選択肢が何箇所で選択されているかカウント
    const count = selectedItems.filter(v => v === value).length;
    // 今回の選択分も含まれているので2以上なら重複とみなす
    if (count >= 2) {
      return false;
    }
    return true;
  },
  message: (field) => "他の質問と重複して選択されています。"
};

const greaterThanEqual = {
  params: ["target"],
  validate(value, { target }) {
    return value >= target;
  },
  message: (field, { target }) => `${target}より大きい値を入力してください。`
};

const lessThanEqual = {
  params: ["target"],
  validate(value, { target }) {
    if (target) {
      return value <= target;
    }
    return true;
  },
  message: (field, { target }) => `${target}より小さい値を入力してください。`
};

const decimal = {
  validate: (value, { decimals = '*', separator = '.' } = {}) => {
    if (value === null || value === undefined || value === '') {
      return {
        valid: false
      };
    }
    if (Number(decimals) === 0) {
      return {
        valid: /^-?\d*$/.test(value),
      };
    }
    const regexPart = decimals === '*' ? '+' : `{1,${decimals}}`;
    const regex = new RegExp(`^[-+]?\\d*(\\${separator}\\d${regexPart})?([eE]{1}[-]?\\d+)?$`);

    return {
      valid: regex.test(value),
    };
  },
  message: '{_field_}は数字のみ使用できます'
};


export { kana, kana_alpha_num, gteThisMonth, emailCheck, adminEmailCheck, duplicateSelectCheck, greaterThanEqual, lessThanEqual, decimal };
